import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useLanguage } from '../context/LanguageContext';

const CookieBanner: React.FC = () => {
  const { language } = useLanguage();
  const nl = language === 'nl';

  return (
    <CookieConsent
      location="bottom"
      cookieName="mk_cookie_consent"
      enableDeclineButton
      buttonText={nl ? 'Accepteer alle cookies' : 'Accept all cookies'}
      declineButtonText={nl ? 'Weiger' : 'Decline'}
      style={{
        background: '#111827',
        color: '#e5e7eb',
        fontSize: '14px',
        padding: '14px',
      }}
      buttonStyle={{
        background: '#e97c00',
        color: '#fff',
        borderRadius: '8px',
        padding: '10px 16px',
        fontWeight: 600,
        fontSize: '14px',
      }}
      declineButtonStyle={{
        background: '#374151',
        color: '#e5e7eb',
        borderRadius: '8px',
        padding: '10px 16px',
        fontWeight: 600,
        fontSize: '14px',
      }}
      expires={180}
    >
      <div style={{ maxWidth: 860, lineHeight: 1.5 }}>
        {nl
          ? 'We gebruiken noodzakelijke cookies en minimale analytische cookies. Geen tracking of advertenties. Lees meer in onze '
          : 'We use necessary cookies and minimal analytics. No tracking or ads. Learn more in our '}
        <a
          href="/cookies"
          style={{ color: '#ffd7a0', fontWeight: 600, textDecoration: 'underline' }}
        >
          {nl ? 'Cookieverklaring' : 'Cookie Policy'}
        </a>
        .
      </div>
    </CookieConsent>
  );
};

export default CookieBanner;
